'use client';

import { Calendar, Monitor, Users } from 'lucide-react';
import { PROJECT_NAME } from '@shared/constants';

/**
 * @group Doctors
 * @summary Benefits section for doctors page
 */
export function DoctorBenefitsSection() {
  const benefits = [
    {
      id: 'scheduling',
      icon: Calendar,
      title: 'Flexible Scheduling',
      description: 'Set your availability around your life, not the other way around. Practise from home, between shifts, or whenever suits you. No minimum hours required.',
    },
    {
      id: 'dashboard',
      icon: Monitor,
      title: 'Smart Clinical Dashboard',
      description: 'Patient triage information presented clearly before consultation. AI-estimated vitals with confidence indicators. Previous consultation history accessible immediately. Documentation templates save time.',
    },
    {
      id: 'support',
      icon: Users,
      title: 'Professional Support',
      description: 'Access to peer consultation when you need a second opinion. Clinical governance support for complex cases. Wellbeing resources recognising the emotional demands of medical practice.',
    },
  ];

  return (
    <section className="py-20 bg-brand-mint">
      <div className="container mx-auto px-4 lg:px-8">
        <h2 className="text-3xl lg:text-4xl font-bold text-[#084349] text-center mb-12">
          Why Doctors Choose {PROJECT_NAME}
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {benefits.map((benefit) => {
            const Icon = benefit.icon;
            return (
              <div
                key={benefit.id}
                className="bg-card p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="w-16 h-16 bg-secondary rounded-xl flex items-center justify-center text-primary mb-6">
                  <Icon className="w-8 h-8" />
                </div>
                <h3 className="text-xl font-semibold text-[#084349] mb-4">
                  {benefit.title}
                </h3>
                <p className="text-[#084349]/80 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
